import visigalogo from "../assets/visigalogo.png";
import hailmary3 from "../assets/hailmary3.png";
import { useTranslation } from "react-i18next";

const History = () => {


    const { t } = useTranslation();

    const history = t("history", { returnObjects: true });

    return (
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 px-4 lg:px-10 mt-0 dark:bg-gray-800">
            {/* First Portion (3 grid) */}
            <div className="lg:col-span-3 bg-gradient-to-b from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-900 p-6 flex flex-col items-center rounded-lg shadow-lg">
                <h1 className="text-3xl sm:text-xl lg:text-2xl text-center font-bold tracking-wide text-gray-900 dark:text-white mb-6">
                    {t("alevel.schoolName")}{" "}
                    <span className="bg-gradient-to-r from-blue-500 to-red-800 text-transparent bg-clip-text block mt-2">
                        {t("alevel.schoolSub")}
                    </span>
                </h1>
                <img
                    src={visigalogo}
                    alt="Visiga Seminary Logo"
                    className="mt-4 w-40 h-auto rounded-full border-4 border-white dark:border-gray-700 shadow-md hover:scale-105 transition-transform duration-300"
                />
            </div>

            {/* Middle Portion (6 grid) */}
            <div className="lg:col-span-6 flex flex-col items-center mt-1 lg:mt-5">
                <h1 className="text-3xl sm:text-4xl lg:text-2xl text-center tracking-wide text-neutral-900 dark:text-neutral-100">
                    {t("history.title")}{" "}
                    <span className="bg-gradient-to-r from-blue-500 to-red-800 text-transparent bg-clip-text">

                    </span>
                </h1>

                <div className="mt-4 text-lg text-neutral-900 dark:text-neutral-100 w-full px-0 sm:px-0 lg:px-0 space-y-4 text-justify">

                    <h1><strong>{t("history.purpose")}</strong></h1>
                    <div className="space-y-4 text-justify">
                        <p>{t("history.introP1")}</p>

                        <p>
                            {t("history.african_priests")}
                            <br />
                            {t("history.priest_shortage_reason")}
                            <br />
                            {t("history.tec_attempt")}
                            <br />
                            {t("history.his_determination")}
                        </p>

                        <p>
                            {t("history.mahenge_creation")}
                            <br />
                            {t("history.morogoro_problems")}
                            <br />
                            {t("history.other_diocese")}
                            <br />
                            {t("history.vocations_lost")}
                            <br />
                            {t("history.land_availability")}
                            <br />
                            {t("history.leadership_challenge")}
                            <br />
                            {t("history.jesuit_support")}
                        </p>

                        <h2 className="text-2xl font-bold mt-6">{t("history.title2")}</h2>

                        <p>
                            {t("history.opening")}
                            <br />
                            {t("history.attendance")}
                        </p>
                    </div>


                    <h1><strong>{t("history.first_seminarians_title")}</strong></h1>
                    <h2>{t("history.first_group_1990")}</h2>
                    <p>
                        {t("history.student_selection")}
                        <br />
                        {t("history.student_distribution")}
                        <br />

                    </p>
                    <p>
                        {t("history.welcoming_priest")}
                        <br />
                        <br />
                        {t("history.preform_one")}
                        <br />
                        <br />
                        {t("history.preform_reasons_title")}
                        <br />
                        <br />
                        <ul className="list-disc pl-5 space-y-2 dark:text-neutral-300 text-neutral-900">
                            <li>{t("history.reason_leadership")}</li>
                            <li>{t("history.reason_textbooks")}</li>
                            <li>{t("history.reason_library")}</li>

                        </ul>
                        <br />
                        <br />
                        <h1><strong>{t("history.title3")}</strong></h1>
                        <br />
                        {t("history.joined_students")}

                        <h1><strong>{t("history.student_list_title")}</strong></h1>
                        <br />
                        <div style={{ fontFamily: 'Arial, sans-serif', fontSize: '14px' }}>
                            <table style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                                border: '3px solid var(--border-color)',
                                color: 'var(--text-color)',
                                backgroundColor: 'var(--bg-color)'
                            }}>
                                <thead>
                                    <tr style={{
                                        backgroundColor: 'var(--header-bg)',
                                        border: '1px solid var(--border-color)'
                                    }}>
                                        <th style={{
                                            padding: '8px',
                                            textAlign: 'left',
                                            border: '1px solid var(--border-color)'
                                        }}>No.</th>
                                        <th style={{
                                            padding: '8px',
                                            textAlign: 'left',
                                            border: '1px solid var(--border-color)'
                                        }}>{t("history.table_rowname1")}</th>
                                        <th style={{
                                            padding: '8px',
                                            textAlign: 'left',
                                            border: '1px solid var(--border-color)'
                                        }}>No.</th>
                                        <th style={{
                                            padding: '8px',
                                            textAlign: 'left',
                                            border: '1px solid var(--border-color)'
                                        }}>{t("history.table_rowname1")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {[
                                        ['1', 'Abraham Chacha', '18', 'Gabriel Benedict'],
                                        ['2', 'Alister Cyprian', '19', 'Gabriel Mahulu'],
                                        ['3', 'Andrew Clement', '20', 'Gaudence Mabula'],
                                        ['4', 'Andrew Kidimwa', '21', 'Henry Remidius'],
                                        ['5', 'Albert Felix', '22', 'Jonas Luanda'],
                                        ['6', 'Allan Paul', '23', 'Joseph Peter'],
                                        ['7', 'Angelo Kashanja', '24', 'Joseph Stephen'],
                                        ['8', 'Costantine Mayapila', '25', 'Keneth Ndomba'],
                                        ['9', 'Daudi Mang’wela', '26', 'Mathew Shayo'],
                                        ['10', 'Deogratias Kitira', '27', 'Melchior Hera'],
                                        ['11', 'Edwin Kigomba', '28', 'Paul Msoka'],
                                        ['12', 'Emmanuel Rubagumya', '29', 'Phillipo Alban'],
                                        ['13', 'Ephraim Bulemela', '30', 'Richard Milanzi'],
                                        ['14', 'Erneus Gama', '31', 'Severin Kisela'],
                                        ['15', 'Ernest Milanzi', '32', 'Sostenes Mbuya'],
                                        ['16', 'Franco Ngongi', '33', 'Stephen Kasigara'],
                                        ['17', 'Fredirick Masalu', '34', 'Thomas Marwa'],
                                        ['', '', '35', 'Yuda Thadei Chikawe']
                                    ].map(([no1, name1, no2, name2], index) => (
                                        <tr key={index}>
                                            <td style={{
                                                padding: '8px',
                                                border: '1px solid var(--border-color)'
                                            }}>{no1}</td>
                                            <td style={{
                                                padding: '8px',
                                                border: '1px solid var(--border-color)'
                                            }}>{name1}</td>
                                            <td style={{
                                                padding: '8px',
                                                border: '1px solid var(--border-color)'
                                            }}>{no2}</td>
                                            <td style={{
                                                padding: '8px',
                                                border: '1px solid var(--border-color)'
                                            }}>{name2}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <br />
                        {t("history.class_established")}
                        <br />
                        {t("history.additional_students")}
                        <br />
                        {t("history.received_by")}
                        <br />
                        <br />
                        {t("history.leadership_change")}

                        <br />
                        {t("history.permanent_teachers")}
                        <br />
                        {t("history.official_classes")}

                    </p>


                    
                    <h1><strong>{t("history.leadership")}</strong></h1>
                    <p>
                        {t("history.leadership_structure")}
                        <br />
                        {t("history.highest_level")}
                        <br />
                        {t("history.second_level")}
                        <br />
                    </p>
                    <p>

                        <h1><strong>{t("history.first_rector")}</strong></h1>
                        <br />
                        {t("history.first_rector_details")}
                        <br />
                        {t("history.first_rector_challenges")}
                        <br />
                        {t("history.first_rector_contributions")}
                        <br />
                        {t("history.first_rector_initiatives")}
                        <br />
                        {t("history.first_rector_collaboration")}
                        <br />
                        {t("history.first_rector_successor")}
                        <br />
                        <br />
                        <h1><strong>{t("history.second_rector")}</strong></h1>
                        {t("history.acting_rector")}
                        <br />
                        {t("history.acting_rector_contributions")}
                        <br />
                        {t("history.second_rector_appointment")}
                        <br />
                        {t("history.second_rector_achievements")}
                        <br />
                        {t("history.second_rector_construction")}
                        <br />
                        {t("history.second_rector_clinic")}

                        <br />
                        {t("history.second_rector_admin_building")}
                        <br />
                        {t("history.second_rector_dining")}
                        <br />
                        <br />
                        {t("history.second_rector_sports")}
                        <br />
                        {t("history.second_rector_academics")}
                        <br />
                        <br />
                        {t("history.second_rector_tragedy")}
                        <br />
                        {t("history.second_rector_accident")}
                        <br />

                    </p>
                    <p>
                        <div style={{
                            fontFamily: 'Arial, sans-serif',
                            fontSize: '14px',
                            color: 'var(--text-color)',
                            backgroundColor: 'var(--bg-color)',
                            padding: '1rem',
                            borderRadius: '12px',
                            overflowX: 'auto',
                        }}>
                            <table style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                                border: '1px solid var(--border-color)'
                            }}>
                                <thead>
                                    <tr style={{ backgroundColor: 'var(--header-bg)', color: 'var(--header-text)' }}>
                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid var(--border-color)' }}>NO.</th>
                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid var(--border-color)' }}>{t("history.table_rowname1")}</th>
                                        <th style={{ padding: '10px', textAlign: 'left', border: '1px solid var(--border-color)' }}>{t("history.table_rowname2")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {[
                                        ['01.', 'Abraham Chacha', 'Ubungo'],
                                        ['02.', 'Angelo Kashaija', 'Msimbazi'],
                                        ['03.', 'Ernest Milanzi', 'Chang’ombe'],
                                        ['04.', 'Constatine Mayapila', 'Ukonga'],
                                        ['05.', 'Gabriel Mahulu', 'Ubungo'],
                                        ['06.', 'Jonas Luanda', 'Chuo kikuu'],
                                        ['07.', 'Richard Milanzi', 'Chang’ombe'],
                                    ].map(([no, jina, parokia], index) => (
                                        <tr key={index}>
                                            <td style={{ padding: '10px', border: '1px solid var(--border-color)' }}>{no}</td>
                                            <td style={{ padding: '10px', border: '1px solid var(--border-color)' }}>{jina}</td>
                                            <td style={{ padding: '10px', border: '1px solid var(--border-color)' }}>{parokia}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <br />
                        {t("history.after_accident")}
                        <br />
                        {t("history.temporary_replacement")}
                        <br />
                        <br />
                        <h1><strong> {t("history.Rector_3")} </strong></h1>
                        <br />
                        {t("history.third_rector")}
                        <br />
                        {t("history.third_rector_intro")}
                        <br />
                        {t("history.third_rector_staff_students")}
                        <br />
                        {t("history.third_rector_infrastructure")}
                        <br />
                        <br />
                        {t("history.third_rector_transport")}
                        <br />
                        <br />
                        {t("history.third_rector_achievements")}
                        <br />
                        {t("history.livestock_achievements")}
                        <br />
                        {t("history.agriculture_achievements")}
                        <br />
                        {t("history.infrastructure_development")}
                        <br />
                        {t("history.teachers_housing")}
                        <br />
                        {t("history.biogas_plant")}
                        <br />
                        {t("history.official_openings")}
                        <br />
                        {t("history.transport_improvements")}
                        <br />
                        <br />
                        {t("history.uniforms_and_parents_day")}
                        <br />
                        {t("history.parents_council_benefits")}
                        <br />
                        {t("history.academic_support")}
                        <br />
                        {t("history.academic_success")}
                        <br />
                        {t("history.leadership_challenges")}
                        <br />
                        {t("history.leadership_duration")}
                        <br />

                        <p>
                            <br />
                            <br />
                            <h1><strong> {t("history.Rector_4")}</strong></h1>
                            <br />
                            {t("history.arrival")}

                            <br />
                            {t("history.students_teachers")}
                            <br />
                            {t("history.teachers_list")}
                            <br />
                            {t("history.priests_list")}
                            <br />
                            {t("history.achievements")}
                            <br />
                            {t("history.animal_trough")}
                            <br />
                            {t("history.challenges")}
                            <br />
                            {t("history.vehicle_glass")}
                            <br />
                            {t("history.end_of_term")}
                            <br />
                            <br />
                            <h1><strong> {t("history.Rector_5")}</strong></h1>
                            <br />

                            {t("history.leadership_change2")}
                            <br />
                            {t("history.priests_departure")}
                            <br />
                            {t("history.martin_dominic_transfer")}

                            <br />
                            {t("history.new_priests_arrival")}
                            <br />
                            {t("history.eusebius_arrival")}
                            <br />
                            {t("history.mathias_mambo")}
                            <br />
                            {t("history.more_priests")}
                            <br />
                            <br />
                            <h1><strong>{t("history.Rector_6")}</strong></h1>

                            {t("history.nzingilwa_leadership")}
                            <br />
                            {t("history.nzingilwa_achievements")}
                            <br />
                            {t("history.mambo_appointment")}
                            <br />
                            {t("history.mambo_start")}
                            <br />
                            <h2><strong>{t("history.work_and_achievements")}</strong></h2>
                            <h3><strong>{t("history.construction_and_renovation")}</strong></h3>
                            {t("history.mambo_projects")}

                            <br />
                            <br />
                            <h2><strong>{t("history.mtazamo5")}</strong></h2>
                            {t("history.intro")}
                            <br />
                            {t("history.intention")}
                            <ol>
                                <li>{t("history.intent_academic")}</li>
                                <li>{t("history.intent_self_sustain")}</li>
                                <li>{t("history.intent_infrastructure")}</li>
                            </ol>
                            <h3><strong>{t("history.academic")}</strong></h3>
                            <h4><strong>{t("history.guardians")}</strong></h4>
                            {t("history.guardians_description")}
                            <br />
                            <h4><strong>{t("history.few_students")}</strong></h4>
                            {t("history.few_students_description")}
                            <br />
                            {t("history.few_students_description2")}
                            <br />
                            {t("history.reasons")}
                            <ol type="a">
                                <li><strong>{t("history.maadili")}</strong> {t("history.reason_morality")}</li>
                                <li><strong>{t("history.tabia")}</strong> {t("history.reason_discipline")}</li>
                                <li><strong>{t("history.wito")}</strong>{t("history.reason_vocation")}</li>
                                <li><strong>{t("history.taaluma")}</strong> {t("history.reason_academic")}</li>
                                <li><strong>{t("history.mikondo")}</strong> {t("history.reason_streams")}</li>
                            </ol>
                            {t("history.conclusion")}
                            <br />
                            {t("history.cost_concern")}
                        </p>
                        <br />
                        <br />
                        <h1><strong> {t("history.mtazamo1")} </strong></h1>


                        <p>{t("history.paragraph1")}</p>

                        <p>{t("history.paragraph2")}</p>

                        <p>{t("history.paragraph3")}</p>

                        <br />
                        <h2><strong>{t("history.section2_title")}</strong></h2>


                        <p>{t("history.paragraph4")}</p>

                        <p>{t("history.paragraph5")}</p>

                        <p>{t("history.paragraph6")}</p>


                        <br />
                        <h2><strong>{t("history.section3_title")}</strong></h2>


                        <p>{t("history.paragraph7")}</p>

                        <ul className="list-disc pl-5 space-y-2 dark:text-neutral-300 text-neutral-900">
                            <li>
                                <strong>{t("history.projects.1")}</strong>{t("history.projects.biolatrine")}
                            </li>
                            <li>
                                <strong>{t("history.projects.2")}</strong> {t("history.projects.water")}
                            </li>
                            <li>
                                <strong>{t("history.projects.3")}</strong>{t("history.projects.clinic")}
                            </li>
                            <li>
                                <strong>{t("history.projects.4")}</strong> {t("history.projects.farming")}
                            </li>
                            <li>
                                <strong>{t("history.projects.5")}</strong> {t("history.projects.livestock")}
                            </li>
                        </ul>

                        <p>{t("history.paragraph8")}</p>

                        <br />
                        <h2><strong>{t("history.section4_title")}</strong></h2>

                        <p>{t("history.paragraph8")}</p>

                        <h3><strong>{t("history.subsection1_title")}</strong></h3>
                        <p>{t("history.paragraph10")}</p>
                        <p>{t("history.paragraph11")}</p>

                        <h3> <strong>{t("history.subsection2_title")}</strong></h3>
                        <p>{t("history.paragraph12")}</p>
                        <p>{t("history.paragraph13")}</p>
                        <ul className="list-disc pl-5 space-y-2 dark:text-neutral-300 text-neutral-900">
                            <li>{t("history.poor_construction")}</li>
                            <li>{t("history.lack_of_funds")}</li>
                        </ul>
                        <p>{t("history.paragraph14")}</p>
                        <br />
                        <br />

                        <h2><strong>{t("history.leadership_under_seventh_rector")}</strong></h2>
                        <p>{t("history.father_eusebius_nzigilwa_second_term")}</p>
                        <ul className="list-disc pl-5 space-y-2 dark:text-neutral-300 text-neutral-900">
                            <li>{t("history.youth_formation")}</li>
                            <li>{t("history.livestock_and_farming")}</li>
                            <li>{t("history.academic_success1")}</li>
                            <li>{t("history.basketball_and_handball_fields")}</li>
                            <li>{t("history.adequate_teachers")}</li>
                            <li>{t("history.relationship_with_wawata")}</li>
                        </ul>
                        <br />
                        <br />
                        <h2><strong>{t("history.leadership_under_eighth_rector")} </strong></h2>
                        <p>{t("history.father_stephano_kaombe_appointment")}</p>
                        <ul className="list-disc pl-5 space-y-2 dark:text-neutral-300 text-neutral-900">
                            <li>{t("history.church_renovation")}</li>
                            <li>{t("history.grotto_construction")}</li>
                            <li>{t("history.fish_pond")}</li>
                            <li>{t("history.solar_power")}</li>
                            <li>{t("history.borehole_water_system")}</li>
                            <li>{t("history.classroom_flooring")}</li>
                            <li>{t("history.student_toilets")}</li>
                            <li>{t("history.land_cruiser_vehicle")}</li>
                        </ul>
                        <p><strong>{t("history.served")}  </strong></p>
                        <ul className="list-disc pl-5 space-y-2 dark:text-neutral-300 text-neutral-900">
                            <li>{t("history.padre_dennis_ngumba")}</li>
                            <li>{t("history.padre_pesambili_masamba")}</li>
                        </ul>

                        <br />
                        <br />
                        <br />
                        <h1><strong>{t("history.padre_dennis_ngumba1")}</strong></h1>
                        <p>
                            {t("history.padre_dennis_ngumba2")}
                        </p>
                        <br />
                        <p>
                            {t("history.padre_dennis_ngumba3")}
                        </p>
                        <p>
                            {t("history.padre_dennis_ngumba4")}

                        </p>
                        <br />

                        <p>

                            {t("history.padre_dennis_ngumba5")}

                        </p>
                        <br />

                        <p>
                            {t("history.padre_dennis_ngumba6")}
                        </p>
                        <br />

                        <p>
                            {t("history.padre_dennis_ngumba7")}
                        </p>
                        <br />

                        <p>
                            {t("history.padre_dennis_ngumba8")}
                        </p>
                        <br />
                        <p>
                            {t("history.padre_dennis_ngumba8")}
                        </p>
                        <br />
                        <br />
                        <h1><strong> {t("history.padre_philip_tairo1")}</strong></h1>
                        <p>
                            {t("history.padre_philip_tairo2")}
                        </p>
                        <p>
                            {t("history.padre_philip_tairo3")}
                        </p>
                        <p>
                            {t("history.padre_philip_tairo4")}
                        </p>
                        <p>
                            {t("history.padre_philip_tairo5")}
                        </p>

                        <br />
                        <ul>
                            <li> <b>{t("history.padre_philip_tairo6")} </b></li>
                            <p>
                                {t("history.padre_philip_tairo7")}
                            </p>

                            <p>
                                {t("history.padre_philip_tairo8")}
                            </p>
                            <p>
                                {t("history.padre_philip_tairo9")}
                            </p>
                            <li><h1><b>{t("history.ujenzi_jengo_utawala_title")}</b></h1> </li>

                            <p>
                                {t("history.ujenzi_jengo_utawala1")}
                            </p>

                            <p>
                                {t("history.ujenzi_jengo_utawala2")}

                            </p>

                            <p>
                                {t("history.ujenzi_jengo_utawala3")}

                            </p>

                            <p>
                                {t("history.ujenzi_jengo_utawala4")}
                            </p>

                            <p>
                                {t("history.ujenzi_jengo_utawala5")}
                            </p>

                            <p>
                                {t("history.ujenzi_jengo_utawala6")}
                            </p>

                            <br />
                            <li> <h1><b>{t("history.ujenzi_madarasa_bweni_title")}</b></h1></li>
                            <p>
                                {t("history.ujenzi_madarasa_bweni1")}
                            </p>
                            <p>
                                {t("history.ujenzi_madarasa_bweni2")}
                            </p>
                            <p>
                                {t("history.ujenzi_madarasa_bweni3")}
                            </p>
                            <p>
                                {t("history.ujenzi_madarasa_bweni4")}
                            </p>

                            <br />

                            <li><h1><b> {t("history.ujenzi_miundombinu_title")} </b></h1></li>
                            <p>
                                {t("history.ujenzi_miundombinu1")}
                            </p>
                            <p>
                                {t("history.ujenzi_miundombinu2")}
                            </p>
                            <p>
                                {t("history.ujenzi_miundombinu3")}
                            </p>
                            <p>
                                {t("history.ujenzi_miundombinu4")}
                            </p>
                            <p>
                                {t("history.ujenzi_miundombinu5")}
                            </p>

                            <br />
                            <li><h1><b> {t("history.ujenzi_kanisa_title")} </b></h1></li>
                            <p>
                                {t("history.ujenzi_kanisa1")}
                            </p>
                            <p>
                                {t("history.ujenzi_kanisa2")}
                            </p>
                            <p>
                                {t("history.ujenzi_kanisa3")}
                            </p>
                            <p>
                                {t("history.ujenzi_kanisa4")}
                            </p>
                            <p>
                                {t("history.ujenzi_kanisa5")}
                            </p>
                            <br />

                            <li><strong>{t("history.ujenzi_title")}</strong></li>
                            <p>
                                {t("history.ujenzi_paragraph1")}
                            </p>
                            <p>
                                {t("history.ujenzi_paragraph2")}
                            </p>
                            <p>
                                {t("history.ujenzi_paragraph3")}
                            </p>
                            <p>
                                {t("history.ujenzi_paragraph4")}
                            </p>
                        </ul>

                        <h2><strong>{t("history.mafanikio_title")}</strong></h2>
                        <p>
                            {t("history.mafanikio_paragraph")}
                        </p>


                        <h2><strong>{t("history.changamoto_title")}</strong></h2>

                        <p>
                            {t("history.changamoto_paragraph")}
                        </p>


                    </p>

                </div>

            </div>

            {/* Third Portion (3 grid) */}
            <div className="lg:col-span-3 bg-gradient-to-b from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-900 p-6 flex flex-col items-center rounded-lg shadow-lg">
                <img
                    src={hailmary3}
                    alt="Hail Mary"
                    className="w-full h-auto max-h-96 object-cover rounded-lg border-4 border-white dark:border-gray-700 shadow-md hover:scale-102 transition-transform duration-300"
                />
                <p className="mt-4 text-center text-gray-600 dark:text-gray-300 italic">
                    {t("alevel.motherText")}
                </p>
            </div>
        </div >
    );
};

export default History;
